// Do NOT add "use client" to this file
import { IOnProductClickBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/IOnProductClickBase";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

export interface ProductLinkProps extends IOnProductClickBase {
  selectedProductOptionToken: string | undefined;
  brandToken: string | undefined;
  showVerticalImagery?: boolean;
}

export const productLinkPropsAdapter = (
  productTile: ILeanProductTile | undefined,
  showVerticalImagery?: boolean
): ProductLinkProps => {
  return {
    token: productTile?.product?.token,
    bestImage: productTile?.best_image,
    images: productTile?.images,
    impressionId: productTile?.product?.impression_id ?? "",
    promotedBy: productTile?.product?.promoted_by,
    selectedProductOptionToken: productTile?.selected_product_option_token,
    brandToken: productTile?.product?.brand_token,
    showVerticalImagery,
  };
};
